import React from "react";

/**
 * The marketing home page's layered background wash.
 *
 * Shared so record landing pages sit on exactly the same surface as the
 * marketing front end instead of maintaining a second copy of the stack.
 */
const PageBackground: React.FC = () => (
  <>
    <div className="fixed inset-0 bg-gradient-to-br from-green-100 via-white to-green-50 -z-10" />
    <div className="fixed inset-0 bg-gradient-to-br from-vedra-hunter/20 via-white/80 to-emerald-400/15 -z-10" />
    <div className="fixed inset-0 bg-gradient-to-r from-green-200/20 via-white/90 to-green-200/20 -z-10" />
    <div className="fixed inset-0 bg-radial-gradient from-white/70 via-transparent to-green-100/30 -z-10" />
  </>
);

export default PageBackground;
